import en from './en';
import zh_cn from './zh_cn';

export default {
  'en': en,
  'zh-CN': zh_cn,
};
